module.exports = __webpack_public_path__ + "img/search_box.13b77a8b.svg";